import omniCategories from './reducers';

import * as omniCategoriesOperations from './operations';
import * as omniCategoriesTypes from './types';
import * as omniCategoriesAction from './actions';

export { omniCategoriesOperations, omniCategoriesTypes, omniCategoriesAction };

export default omniCategories;
